export enum NotificationType {
  GenericNotification = 1,
  GenericPopupNotification = 2,
  LiveClassNotification = 3,
  PaymentNotification = 4,
  LevelComplete = 5,
  UnitComplete = 6,
  AccountStatusNotification = 7,
  RequestToWorkNotification = 8,
  RequestToTeachNotification = 9,
  GenericPlacementTestNotification = 10,
  DelinquentAccountStatusNotification = 11,
  LiveClassSurveyNotification = 12,
  GearCheckNotification = 13,
  LiveClassDeniedNotification = 14,
  LiveClassNeedHelpNotification = 15,
  LiveClassTeacherNotInCRNotification = 16,
  LiveClassReminderNotification = 17,
  FeaturePopUpNotification = 18,
  LevelZeroNotification = 19,
  TeacherFeedbackNotification = 20,
  SuggestedActivitiesNotification = 21,
  ProfileCompletionNotification = 22,
  LiveClassTeacherReminderNotification = 23,
  MidLevelTestNotification = 24,
  GamificationNotification = 25,
}
